import { mainSiteUrl } from '@/mocks/categories';

export default function SeoIntroSection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <p className="text-sm font-medium text-primary-600 uppercase tracking-wider mb-3">Why Mulebuy Spreadsheet Matters</p>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900 leading-tight">
            Smart Sourcing Starts With Structured Data
          </h2>
        </div>

        <div className="prose prose-sm md:prose-base max-w-none text-foreground-700 leading-relaxed space-y-5">
          <p>
            The <strong>mulebuy spreadsheet</strong> has become one of the most important tools for users looking to organize and optimize their buying process through Mulebuy agents and sourcing platforms. A mulebuy spreadsheet typically contains structured data such as product listings, pricing information, shipping details, and agent comparisons.
          </p>
          <p>
            With the growing demand for efficient sourcing tools, more users are searching for reliable <strong>mulebuy spreadsheet lists</strong> that are updated and verified. This website is designed to provide a centralized hub for all mulebuy spreadsheet resources, including comparisons, guides, and updated tools that help users make better purchasing decisions.
          </p>
          <p>
            Whether you are a beginner or an advanced user, understanding how to use a <strong>mulebuy spreadsheet</strong> can significantly improve your sourcing efficiency. The structured format allows you to compare different buying agents, track product availability, analyze pricing trends, and ultimately improve your purchasing decisions with data-driven insights.
          </p>
          <p>
            Explore our curated lists below to find the best options available in 2026, and visit the{' '}
            <a href={mainSiteUrl} target="_blank" rel="noopener nofollow" className="text-primary-600 hover:text-primary-700 underline cursor-pointer font-medium">
              main platform
            </a>{' '}
            for direct access to all product categories and the latest spreadsheet tools.
          </p>
        </div>
      </div>
    </section>
  );
}